import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconTextStrikethrough';
/** Renders an SVG icon. */
const SvgTextStrikethrough = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.702 6a3.772 3.772 0 0 0-3.07 5.965l.042.058c.335.47.77.857 1.274 1.137L16.259 15H27a1 1 0 1 1 0 2h-7.14l.164.091a5.9 5.9 0 0 1 1.93 1.723l.041.059A5.773 5.773 0 0 1 17.298 28h-3.394a6 6 0 0 1-5.821-4.545l-.053-.212a1 1 0 1 1 1.94-.485l.053.212a4 4 0 0 0 3.88 3.03h3.395a3.772 3.772 0 0 0 3.07-5.965l-.042-.058a3.9 3.9 0 0 0-1.274-1.137L15.741 17H5a1 1 0 1 1 0-2h7.14l-.164-.091a5.9 5.9 0 0 1-1.93-1.723l-.041-.059A5.772 5.772 0 0 1 14.702 4h2.625c2.617 0 4.9 1.781 5.534 4.32l.11.437a1 1 0 1 1-1.941.486l-.11-.437A3.704 3.704 0 0 0 17.328 6z"
      />
    </svg>
  );
};
SvgTextStrikethrough.displayName = displayName;
export default SvgTextStrikethrough;
